import { NextSeo } from 'next-seo';

import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from '../../next-seo.config';
import { AboutMatcha } from '../components/AboutMatcha';

const ABOUT_MATCHA_TITLE = 'About Matcha DEX aggregator';
const ABOUT_MATCHA_DESCRIPTION =
  'Trade over 9 million tokens with liquidity from 130+ DEXs on Matcha DEX aggregator. Token swaps, limit orders, and cross chain trades, all in one place!';

const AboutMatchaPage = () => {
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={ABOUT_MATCHA_TITLE}
        description={ABOUT_MATCHA_DESCRIPTION}
        canonical={`${ROOT_URL_PRODUCTION}/about-matcha-dex-aggregator`}
        openGraph={{
          images: [
            {
              url: `${ROOT_URL_PRODUCTION}/images/og/social-matcha-banner.jpg`,
              width: 1200,
              height: 630,
              alt: 'Matcha',
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: ABOUT_MATCHA_TITLE,
          },
          {
            name: 'twitter:description',
            content: ABOUT_MATCHA_DESCRIPTION,
          },
          {
            name: 'twitter:image',
            content: `${ROOT_URL_PRODUCTION}/images/og/social-matcha-banner.jpg`,
          },
          {
            name: 'twitter:url',
            content: `${ROOT_URL_PRODUCTION}/about-matcha-dex-aggregator`,
          },
        ]}
      />
      <AboutMatcha />
    </>
  );
};

export default AboutMatchaPage;
